import React from 'react';
import { ExposureWidgetItemBrand } from '../../../../../../../types/widget';
import Img from '../../../../../../../components/Img/Img';
import notFoundImg from '../../../../../../../static/images/common/not-found-img.png';
import { BrandCardStyle } from './style';

interface BrandWidgetCardProps {
  widgetBrandItem: ExposureWidgetItemBrand;
}

const BrandWidgetCard = (props: BrandWidgetCardProps): JSX.Element => {
  const { widgetBrandItem } = props;

  const mainImg = widgetBrandItem.attachment?.[0];

  return (
    <BrandCardStyle>
      <Img clickAble={false} src={mainImg?.url || notFoundImg} />
      <div className="title">
        {widgetBrandItem.title ? (
          widgetBrandItem.title
        ) : (
          <span className="require-info">위젯 브랜드 아이템 타이틀을 설정해주세요.</span>
        )}
      </div>
      {widgetBrandItem.contents && <div className="contents">{widgetBrandItem.contents}</div>}
    </BrandCardStyle>
  );
};

export default BrandWidgetCard;
